export default __webpack_public_path__ + "static/media/home2.242bf9aa.jpg";